const category = [
    {
        display: 'Áo Polo',
        categoryPath: 'polo-shirt',
    },
    {
        display: 'Áo phông',
        categoryPath: 't-shirt',
    },
    {
        display: 'Áo sơ mi',
        categoryPath: 'shirt',
    },
    {
        display: 'Quần short',
        categoryPath: 'short',
    },
    {
        display: 'Quần dài',
        categoryPath: 'jean',
    },
]

export default category;